var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 0c-3.31371 0-6 2.68629-6 6s2.68629 6 6 6 6-2.68629 6-6-2.68629-6-6-6zm-2.5 5.5h5c.27614 0 .5.22386.5.5s-.22386.5-.5.5h-5c-.27614 0-.5-.22386-.5-.5s.22386-.5.5-.5z",
    fill: "#373f41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShow);
export default __webpack_public_path__ + "static/media/no-show.6d8f7656faf33e8da1f7c4675f028130.svg";
export { ForwardRef as ReactComponent };